import script from "./datos_personales.vue?vue&type=script&setup=true&lang=js"
export * from "./datos_personales.vue?vue&type=script&setup=true&lang=js"

import "./datos_personales.vue?vue&type=style&index=0&id=bfde3704&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfde3704"]])

export default __exports__